<form
  [formGroup]="formEstabelecimento"
  class="etapa-form"
  (ngSubmit)="salvar()"
>
  <div class="n-form-grid">
    <!--
    IDENTIDADE VISUAL - temporariamente oculto (reativar quando necessário)
    Foto de perfil e capa do estabelecimento
    <section class="n-image-upload-section mb-5">
      <h4 class="n-section-title">
        <i class="pi pi-images"></i>
        Identidade visual
      </h4>

      <div class="n-images-grid">
        Foto de Perfil
        <div
          class="n-image-upload-card"
          [class.n-uploading]="uploadingPerfil()"
          [class.n-drag-active]="dragActivePerfil()"
          [class.n-error]="errorPerfil()"
          [class.n-success]="successPerfil()"
          [class.n-disabled]="salvando"
          (dragover)="onDragOver($event, 'perfil')"
          (dragleave)="onDragLeave($event, 'perfil')"
          (drop)="onDrop($event, 'perfil')"
        >
          <div class="n-image-label">
            <i class="pi pi-user"></i>
            Foto de Perfil
          </div>

          @if (previewPerfil) {
          <div
            class="n-image-preview n-profile-preview"
            role="button"
            [attr.tabindex]="salvando ? -1 : 0"
            [attr.aria-disabled]="salvando ? 'true' : 'false'"
            (click)="salvando ? null : selectImage('perfil')"
            (keydown.enter)="salvando ? null : selectImage('perfil')"
            (keydown.space)="
              $event.preventDefault(); salvando ? null : selectImage('perfil')
            "
          >
            <img [src]="previewPerfil" alt="Foto de perfil" />
            <div class="n-image-overlay">
              <button
                type="button"
                pButton
                icon="pi pi-upload"
                [disabled]="salvando"
                (click)="
                  $event.stopPropagation();
                  salvando ? null : selectImage('perfil')
                "
              >
                Trocar
              </button>
              <button
                type="button"
                pButton
                icon="pi pi-trash"
                severity="danger"
                [disabled]="salvando"
                (click)="
                  $event.stopPropagation();
                  salvando ? null : removeImage('perfil')
                "
              >
                Remover
              </button>
            </div>
          </div>
          } @else {
          <div
            class="n-drag-zone"
            role="button"
            [attr.tabindex]="salvando ? -1 : 0"
            [attr.aria-disabled]="salvando ? 'true' : 'false'"
            (click)="salvando ? null : selectImage('perfil')"
            (keydown.enter)="salvando ? null : selectImage('perfil')"
            (keydown.space)="
              $event.preventDefault(); salvando ? null : selectImage('perfil')
            "
          >
            <div class="n-empty-state">
              <i class="pi pi-cloud-upload"></i>
              <p class="n-instruction">
                {{ 'BARDO_ESTABELECIMENTOS.MODAL.DRAG_PERFIL' | translate }}
              </p>
              <span class="n-text-secondary">{{ 'PRIMEIRO_ACESSO.ETAPA_ESTABELECIMENTO.FORMATO_PNG_JPG_5MB' | translate }}</span>
              <button
                type="button"
                pButton
                icon="pi pi-upload"
                [disabled]="salvando"
                (click)="
                  $event.stopPropagation();
                  salvando ? null : selectImage('perfil')
                "
              >
                {{ 'BARDO_ESTABELECIMENTOS.MODAL.SELECIONAR_ARQUIVO' | translate }}
              </button>
              <span class="n-info-text">{{ 'BARDO_ESTABELECIMENTOS.MODAL.PROPORCAO_1_1' | translate }}</span>
            </div>
          </div>
          }

          <input
            #fileInputPerfil
            type="file"
            accept="image/*"
            (change)="onFileSelect('perfil', $event)"
            hidden
          />

          @if (uploadingPerfil()) {
          <div class="n-progress-bar">
            <div
              class="n-progress-fill"
              [style.width.%]="uploadProgressPerfil()"
            ></div>
          </div>
          }
        </div>

        Foto de Capa
        <div
          class="n-image-upload-card"
          [class.n-uploading]="uploadingCapa()"
          [class.n-drag-active]="dragActiveCapa()"
          [class.n-error]="errorCapa()"
          [class.n-success]="successCapa()"
          [class.n-disabled]="salvando"
          (dragover)="onDragOver($event, 'capa')"
          (dragleave)="onDragLeave($event, 'capa')"
          (drop)="onDrop($event, 'capa')"
        >
          <div class="n-image-label">
            <i class="pi pi-image"></i>
            Foto de Capa
          </div>

          @if (previewCapa) {
          <div
            class="n-image-preview n-cover-preview"
            role="button"
            [attr.tabindex]="salvando ? -1 : 0"
            [attr.aria-disabled]="salvando ? 'true' : 'false'"
            (click)="salvando ? null : selectImage('capa')"
            (keydown.enter)="salvando ? null : selectImage('capa')"
            (keydown.space)="
              $event.preventDefault(); salvando ? null : selectImage('capa')
            "
          >
            <img [src]="previewCapa" alt="Foto de capa" />
            <div class="n-image-overlay">
              <button
                type="button"
                pButton
                icon="pi pi-upload"
                [disabled]="salvando"
                (click)="
                  $event.stopPropagation();
                  salvando ? null : selectImage('capa')
                "
              >
                Trocar
              </button>
              <button
                type="button"
                pButton
                icon="pi pi-trash"
                severity="danger"
                [disabled]="salvando"
                (click)="
                  $event.stopPropagation();
                  salvando ? null : removeImage('capa')
                "
              >
                Remover
              </button>
            </div>
          </div>
          } @else {
          <div
            class="n-drag-zone"
            role="button"
            [attr.tabindex]="salvando ? -1 : 0"
            [attr.aria-disabled]="salvando ? 'true' : 'false'"
            (click)="salvando ? null : selectImage('capa')"
            (keydown.enter)="salvando ? null : selectImage('capa')"
            (keydown.space)="
              $event.preventDefault(); salvando ? null : selectImage('capa')
            "
          >
            <div class="n-empty-state">
              <i class="pi pi-images"></i>
              <p class="n-instruction">
                {{ 'BARDO_ESTABELECIMENTOS.MODAL.DRAG_CAPA' | translate }}
              </p>
              <span class="n-text-secondary">{{ 'PRIMEIRO_ACESSO.ETAPA_ESTABELECIMENTO.FORMATO_PNG_JPG_5MB' | translate }}</span>
              <button
                type="button"
                pButton
                icon="pi pi-upload"
                [disabled]="salvando"
                (click)="
                  $event.stopPropagation();
                  salvando ? null : selectImage('capa')
                "
              >
                {{ 'BARDO_ESTABELECIMENTOS.MODAL.SELECIONAR_ARQUIVO' | translate }}
              </button>
              <span class="n-info-text">{{ 'BARDO_ESTABELECIMENTOS.MODAL.TAMANHO_IDEAL_CAPA' | translate }}</span>
            </div>
          </div>
          }

          <input
            #fileInputCapa
            type="file"
            accept="image/*"
            (change)="onFileSelect('capa', $event)"
            hidden
          />

          @if (uploadingCapa()) {
          <div class="n-progress-bar">
            <div
              class="n-progress-fill"
              [style.width.%]="uploadProgressCapa()"
            ></div>
          </div>
          }
        </div>
      </div>
    </section>
    -->

    <!-- Dados Básicos -->
    <div class="n-form-section">
      <h4 class="n-section-title">{{ 'PRIMEIRO_ACESSO.SECAO_INFO_BASICA' | translate }}</h4>

      <div class="n-field-group">
        <div class="n-field n-field-full">
          <lib-form-field
            [label]="'PRIMEIRO_ACESSO.LABEL_NOME' | translate"
            controlName="nome"
            [required]="true"
          >
            <input
              pInputText
              id="nome"
              formControlName="nome"
              [placeholder]="'PRIMEIRO_ACESSO.PLACEHOLDER_NOME' | translate"
            />
          </lib-form-field>
        </div>

        <div class="n-field n-field-full">
          <lib-form-field
            [label]="'PRIMEIRO_ACESSO.LABEL_NICHO' | translate"
            controlName="nicho"
            [required]="true"
          >
            @if (deviceService.$isMobile()) {
            <lib-n-multiselect
              [multiple]="false"
              formControlName="nicho"
              [options]="nichos"
              optionLabel="label"
              optionValue="value"
              [placeholder]="'PRIMEIRO_ACESSO.PLACEHOLDER_NICHO' | translate"
            />
            } @else {
            <p-select
              id="nicho"
              formControlName="nicho"
              [options]="nichos"
              optionLabel="label"
              optionValue="value"
              [placeholder]="'PRIMEIRO_ACESSO.PLACEHOLDER_NICHO' | translate"
              styleClass="w-full"
            />
            }
          </lib-form-field>
        </div>
      </div>

      <div class="n-field-group n-field-group--telefone">
        <div class="n-field">
          <lib-form-field
            [label]="'PRIMEIRO_ACESSO.LABEL_TELEFONE' | translate"
            controlName="telefone"
            [required]="true"
          >
            <lib-phone-input
              [value]="formEstabelecimento.get('telefone')?.value ?? ''"
              (valueChange)="onTelefoneChange($event)"
            />
          </lib-form-field>
        </div>

        <div class="n-field">
          <lib-form-field [label]="'PRIMEIRO_ACESSO.LABEL_ABRE_FERIADO' | translate" controlName="abreFeriado">
            <p-selectButton
              id="abreFeriado"
              formControlName="abreFeriado"
              [options]="simNaoOptions"
              optionLabel="label"
              optionValue="value"
            />
          </lib-form-field>
        </div>
      </div>

      <div class="n-field-group">
        <div class="n-field">
          <lib-form-field [label]="'PRIMEIRO_ACESSO.LABEL_REDE_SOCIAL' | translate" controlName="redeSocial">
            <input
              pInputText
              id="redeSocial"
              formControlName="redeSocial"
              [placeholder]="'PRIMEIRO_ACESSO.PLACEHOLDER_REDE_SOCIAL' | translate"
            />
          </lib-form-field>
        </div>

        <div class="n-field">
          <lib-form-field [label]="'PRIMEIRO_ACESSO.LABEL_WEBSITE' | translate" controlName="website">
            <input
              pInputText
              id="website"
              formControlName="website"
              [placeholder]="'PRIMEIRO_ACESSO.PLACEHOLDER_WEBSITE' | translate"
            />
          </lib-form-field>
        </div>
      </div>

      <!-- Horários de Funcionamento -->
      <div class="n-field-group">
        <div class="n-field">
          <lib-form-field
            [label]="'PRIMEIRO_ACESSO.LABEL_HORA_ABERTURA' | translate"
            controlName="horaAbertura"
            [required]="true"
          >
            <p-datepicker
              inputId="horaAbertura"
              formControlName="horaAbertura"
              [showIcon]="true"
              [timeOnly]="true"
              [showTime]="true"
              iconDisplay="input"
              stepMinute="30"
              hourFormat="24"
              placeholder="08:00"
              styleClass="w-full"
              [class.ng-invalid]="horariosInvalidos"
              [class.ng-dirty]="horariosInvalidos"
            />
          </lib-form-field>
        </div>

        <div class="n-field">
          <lib-form-field
            [label]="'PRIMEIRO_ACESSO.LABEL_HORA_FECHAMENTO' | translate"
            controlName="horaFechamento"
            [required]="true"
          >
            <p-datepicker
              inputId="horaFechamento"
              formControlName="horaFechamento"
              [showIcon]="true"
              [timeOnly]="true"
              [showTime]="true"
              iconDisplay="input"
              stepMinute="30"
              hourFormat="24"
              placeholder="18:00"
              styleClass="w-full"
              [class.ng-invalid]="horariosInvalidos"
              [class.ng-dirty]="horariosInvalidos"
            />
          </lib-form-field>
        </div>
      </div>

      <div class="n-field-group">
        <div class="n-field n-field-full">
          <lib-form-field
            [label]="'PRIMEIRO_ACESSO.LABEL_DIAS_FUNCIONAMENTO' | translate"
            controlName="diasFuncionamento"
            [required]="true"
          >
            @if (deviceService.$isMobile()) {
            <lib-n-multiselect
              formControlName="diasFuncionamento"
              [options]="diasSemana"
              optionLabel="label"
              optionValue="id"
              [placeholder]="'PRIMEIRO_ACESSO.PLACEHOLDER_DIAS_FUNCIONAMENTO' | translate"
              [maxSelectedLabels]="3"
              [selectedItemsLabel]="'PRIMEIRO_ACESSO.ITENS_SELECIONADOS' | translate"
              [showHeader]="false"
            />
            } @else {
            <p-multiSelect
              id="diasFuncionamento"
              formControlName="diasFuncionamento"
              [options]="diasSemana"
              optionLabel="label"
              optionValue="id"
              [maxSelectedLabels]="3"
              [placeholder]="'PRIMEIRO_ACESSO.PLACEHOLDER_DIAS_FUNCIONAMENTO' | translate"
              [selectedItemsLabel]="'PRIMEIRO_ACESSO.ITENS_SELECIONADOS' | translate"
              [emptyMessage]="'GLOBAL.NENHUM_RESULTADO' | translate"
              [emptyFilterMessage]="'GLOBAL.NENHUM_RESULTADO' | translate"
              appendTo="body"
            />
            }
          </lib-form-field>
        </div>
      </div>
    </div>

    <!-- Endereço -->
    <div class="n-form-section">
      <h4 class="n-section-title">{{ 'PRIMEIRO_ACESSO.SECAO_ENDERECO' | translate }}</h4>

      <div class="n-field-group">
        <div class="n-field">
          <lib-form-field [label]="'PRIMEIRO_ACESSO.LABEL_PAIS' | translate" controlName="pais" [required]="true">
            @if (deviceService.$isMobile()) {
            <lib-n-multiselect
              [multiple]="false"
              id="pais"
              formControlName="pais"
              [options]="paises"
              optionLabel="nome"
              optionValue="codigo"
              [placeholder]="'PRIMEIRO_ACESSO.PLACEHOLDER_PAIS' | translate"
              (selectionChange)="aoSelecionarPais($event.value)"
            />
            } @else {
            <p-select
              id="pais"
              formControlName="pais"
              [options]="paises"
              optionLabel="nome"
              optionValue="codigo"
              [placeholder]="'PRIMEIRO_ACESSO.PLACEHOLDER_PAIS' | translate"
              [filter]="true"
              filterBy="nome"
              [emptyMessage]="'PRIMEIRO_ACESSO.NENHUM_PAIS' | translate"
              [emptyFilterMessage]="'PRIMEIRO_ACESSO.NENHUM_PAIS' | translate"
              appendTo="body"
              styleClass="w-full"
              (onChange)="aoSelecionarPais($event.value)"
            />
            }
          </lib-form-field>
        </div>
      </div>

      @if (ehEnderecoBrasil()) {
      <div class="n-field-group">
        <div class="n-field">
          <lib-form-field [label]="'PRIMEIRO_ACESSO.LABEL_CEP' | translate" controlName="cep" [required]="true">
            <p-inputMask
              id="cep"
              formControlName="cep"
              mask="99999-999"
              (onComplete)="buscarCep()"
              placeholder="00000-000"
            />
          </lib-form-field>
        </div>

        <div class="n-field">
          <lib-form-field
            [label]="'PRIMEIRO_ACESSO.LABEL_LOGRADOURO' | translate"
            controlName="logradouro"
            [required]="true"
          >
            <input
              pInputText
              id="logradouro"
              formControlName="logradouro"
              [placeholder]="'PRIMEIRO_ACESSO.PLACEHOLDER_LOGRADOURO' | translate"
            />
          </lib-form-field>
        </div>
      </div>

      <div class="n-field-group">
        <div class="n-field">
          <lib-form-field [label]="'PRIMEIRO_ACESSO.LABEL_NUMERO' | translate" controlName="numero" [required]="true">
            <input
              pInputText
              id="numero"
              formControlName="numero"
              [placeholder]="'PRIMEIRO_ACESSO.PLACEHOLDER_NUMERO' | translate"
            />
          </lib-form-field>
        </div>

        <div class="n-field">
          <lib-form-field [label]="'PRIMEIRO_ACESSO.LABEL_COMPLEMENTO' | translate" controlName="complemento">
            <input
              pInputText
              id="complemento"
              formControlName="complemento"
              [placeholder]="'PRIMEIRO_ACESSO.PLACEHOLDER_COMPLEMENTO' | translate"
            />
          </lib-form-field>
        </div>
      </div>

      <div class="n-field-group">
        <div class="n-field">
          <lib-form-field [label]="'PRIMEIRO_ACESSO.LABEL_BAIRRO' | translate" controlName="bairro" [required]="true">
            <input
              pInputText
              id="bairro"
              formControlName="bairro"
              [placeholder]="'PRIMEIRO_ACESSO.PLACEHOLDER_BAIRRO' | translate"
            />
          </lib-form-field>
        </div>

        <div class="n-field">
          <lib-form-field [label]="'PRIMEIRO_ACESSO.LABEL_CIDADE' | translate" controlName="cidade" [required]="true">
            <input
              pInputText
              id="cidade"
              formControlName="cidade"
              [placeholder]="'PRIMEIRO_ACESSO.PLACEHOLDER_CIDADE' | translate"
            />
          </lib-form-field>
        </div>
      </div>

      <div class="n-field-group">
        <div class="n-field">
          <lib-form-field [label]="'PRIMEIRO_ACESSO.LABEL_UF' | translate" controlName="estado" [required]="true">
            @if (deviceService.$isMobile()) {
            <lib-n-multiselect
              [multiple]="false"
              id="estado"
              formControlName="estado"
              [options]="estados"
              [placeholder]="'PRIMEIRO_ACESSO.PLACEHOLDER_ESTADO' | translate"
            />
            } @else {
            <p-select
              id="estado"
              formControlName="estado"
              [options]="estados"
              [placeholder]="'PRIMEIRO_ACESSO.PLACEHOLDER_ESTADO' | translate"
              [emptyMessage]="'GLOBAL.NENHUM_RESULTADO' | translate"
              [filter]="true"
              appendTo="body"
            />
            }
          </lib-form-field>
        </div>
      </div>
      } @else {
      <div class="n-field-group">
        <div class="n-field">
          <lib-form-field
            [label]="'PRIMEIRO_ACESSO.LABEL_ADDRESS_LINE' | translate"
            controlName="logradouro"
            [required]="true"
          >
            <input
              pInputText
              id="logradouro"
              formControlName="logradouro"
              [placeholder]="'PRIMEIRO_ACESSO.PLACEHOLDER_ADDRESS_LINE' | translate"
            />
          </lib-form-field>
        </div>

        <div class="n-field">
          <lib-form-field
            [label]="'PRIMEIRO_ACESSO.LABEL_ADDRESS_NUMBER' | translate"
            controlName="numero"
            [required]="true"
          >
            <input
              pInputText
              id="numero"
              formControlName="numero"
              placeholder="12"
            />
          </lib-form-field>
        </div>
      </div>

      <div class="n-field-group">
        <div class="n-field">
          <lib-form-field [label]="'PRIMEIRO_ACESSO.LABEL_CITY' | translate" controlName="cidade" [required]="true">
            <input
              pInputText
              id="cidade"
              formControlName="cidade"
              [placeholder]="'PRIMEIRO_ACESSO.LABEL_CITY' | translate"
            />
          </lib-form-field>
        </div>

        <div class="n-field">
          <lib-form-field
            [label]="'PRIMEIRO_ACESSO.LABEL_REGION' | translate"
            controlName="estado"
            [required]="true"
          >
            <input
              pInputText
              id="estado"
              formControlName="estado"
              [placeholder]="'PRIMEIRO_ACESSO.LABEL_REGION' | translate"
            />
          </lib-form-field>
        </div>
      </div>

      <div class="n-field-group">
        <div class="n-field">
          <lib-form-field
            [label]="'PRIMEIRO_ACESSO.LABEL_POSTAL_CODE' | translate"
            controlName="cep"
            [required]="true"
          >
            <input
              pInputText
              id="cep"
              formControlName="cep"
              [placeholder]="'PRIMEIRO_ACESSO.LABEL_POSTAL_CODE' | translate"
              maxlength="20"
            />
          </lib-form-field>
        </div>
      </div>
      }
    </div>
  </div>

  <div class="n-form-actions">
    <p-button
      [label]="'PRIMEIRO_ACESSO.BOTAO_SALVAR_ENTRAR' | translate"
      type="submit"
      icon="pi pi-arrow-right"
      iconPos="right"
      styleClass="n-button-prim"
      [loading]="salvando"
      [disabled]="salvando || !isFormValid"
    />
  </div>
</form>
